module.exports = __webpack_public_path__ + "img/nb-2.b263ab68.png";